<template>
  <div id="app">
    <router-view v-if="!this.$store.state.auth.login_timeout && !this.$store.state.auth.login_locked"/>
    <login_lock v-else-if="this.$store.state.auth.login_locked"></login_lock>
    <vue-snotify></vue-snotify>
    <!-- ADD NOTE MODAL -->
    <modal_add_note v-if="$store.state.notes.add_modal"></modal_add_note>
    <!-- VIEW NOTE MODAL -->
    <modal_view_note v-if="$store.state.notes.view_modal"></modal_view_note>
    <!-- EDIT NOTE MODAL -->
    <modal_edit_note v-if="$store.state.notes.edit_modal"></modal_edit_note>
    <!-- VIEW NOTES LIST MODAL -->
    <modal_view_notes_list v-if="$store.state.notes.view_list_modal"></modal_view_notes_list>

    <!-- VIEW LOG MODAL -->
    <modal_view_log v-if="$store.state.logs.view_modal"></modal_view_log>

    <!-- ADD FILE MODAL -->
    <modal_add_file v-if="$store.state.files.add_modal"></modal_add_file>
    <modal_upload_file v-if="$store.state.files.add_modal"></modal_upload_file>
    <!-- VIEW FILE MODAL -->
    <modal_view_file v-if="$store.state.files.view_modal"></modal_view_file>
    <!-- VIEW FILE TAX MODAL -->
    <modal_view_tax_file v-if="$store.state.files.tax_file.view_modal"></modal_view_tax_file>
    <!-- VIEW COMPANY SERVICE REPORT FILE MODAL -->
    <modal_view_service_report_file v-if="$store.state.files.service_report_file.view_modal"></modal_view_service_report_file>
    <!-- ADD CONTACT MODAL -->
    <modal_add_contact v-if="$store.state.contacts.add_modal"></modal_add_contact>
    <!-- VIEW CONTACT MODAL -->
    <modal_view_contact v-if="$store.state.contacts.view_modal"></modal_view_contact>
    <!-- EDIT CONTACT MODAL -->
    <modal_edit_contact v-if="$store.state.contacts.edit_modal"></modal_edit_contact>

    <!-- ADD ADDRESS MODAL -->
    <modal_add_address v-if="$store.state.addresses.add_modal"></modal_add_address>
    <!-- VIEW ADDRESS MODAL -->
    <modal_view_address v-if="$store.state.addresses.view_modal"></modal_view_address>
    <!-- EDIT ADDRESS MODAL -->
    <modal_edit_address v-if="$store.state.addresses.edit_modal"></modal_edit_address>

    <!-- ADD JOB RATE MODAL -->
    <modal_add_job_rate v-if="$store.state.order_rates.add_job_rate_modal"></modal_add_job_rate>

    <!-- VIEW INFO MAINTENANCE -->
    <!--<modal_info_maintenance v-if="this.$store.state.auth.me" /> -->
  </div>
</template>

<script>
import login_lock from "components/auth/login_lock"

import modal_add_note from 'components/partials/modals/notes/add_note'
import modal_view_note from 'components/partials/modals/notes/view_note'
import modal_edit_note from 'components/partials/modals/notes/edit_note'
import modal_view_notes_list from 'components/partials/modals/notes/view_notes_list'

import modal_view_log from 'components/partials/modals/logs/view_log'

import modal_add_file from 'components/partials/modals/files/add_file'
import modal_upload_file from 'components/partials/modals/files/upload_file'
import modal_view_file from 'components/partials/modals/files/view_file'
import modal_view_tax_file from 'components/partials/modals/files/view_tax_file';
import modal_view_service_report_file from 'components/partials/modals/files/view_service_report_file';

import modal_add_contact from 'components/partials/modals/contacts/add_contact'
import modal_view_contact from 'components/partials/modals/contacts/view_contact'
import modal_edit_contact from 'components/partials/modals/contacts/edit_contact'

import modal_add_address from 'components/partials/modals/addresses/add_address'
import modal_view_address from 'components/partials/modals/addresses/view_address'
import modal_edit_address from 'components/partials/modals/addresses/edit_address'

import modal_add_job_rate from 'components/partials/modals/orders/add_rate'

import modal_info_maintenance from 'components/partials/modals/info/maintenance';

export default {
  name: "App",
  components: {
    login_lock,
    modal_add_note,
    modal_view_note,
    modal_edit_note,
    modal_view_notes_list,
    modal_view_log,
    modal_add_file,
    modal_upload_file,
    modal_view_file,
    modal_view_tax_file,
    modal_add_contact,
    modal_view_contact,
    modal_edit_contact,
    modal_add_address,
    modal_view_address,
    modal_edit_address,
    modal_add_job_rate,
    modal_view_service_report_file,
    modal_info_maintenance,
  },
  beforeCreate() {
    this.$store.commit('HIDE_NOTE_MODALS');
    this.$store.commit('HIDE_VIEW_LOG_MODAL');
    this.$store.commit('HIDE_FILE_MODAL');
    this.$store.commit('HIDE_FILE_TAX_MODAL');
    this.$store.commit('HIDE_CONTACT_MODAL');
    this.$store.commit('HIDE_ADDRESS_MODALS')
    this.$store.commit('HIDE_JOB_RATE_MODAL')
    this.$store.commit('HIDE_SERVICE_REPORT_MODAL')
  },
  beforeMount() {

    // Event Bus
    this.$bus.$on('note::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_NOTES', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_NOTES', {action: false}));
      }
    });
    this.$bus.$on('logs::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_LOGS', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_LOGS', {action: false}));
      }
    });
    this.$bus.$on('file::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_FILES', {type: $event.type, action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_FILES', {action: false}));
      }
    });

    this.$bus.$on('worker_tax_hmrc::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_GENIUS_TAX', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_GENIUS_TAX', {action: false}))
      }
    });
    this.$bus.$on('entity_test::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_ENTITY_TEST', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_ENTITY_TEST', {action: false}));
      }
    });
    this.$bus.$on('cis_tax_status::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_CIS_STATUS', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_CIS_STATUS', {action: false}));
      }
    });
    this.$bus.$on('company_cis_tax_status::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_COMPANY_CIS_STATUS', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_COMPANY_CIS_STATUS', {action: false}));
      }
    });

    this.$bus.$on('address::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_ADDRESSES', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_ADDRESSES', {action: false}))
      }
    });
    this.$bus.$on('email::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_EMAILS', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_EMAILS', {action: false}))
      }
    });
    this.$bus.$on('phone::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_PHONES', {type: $event.type, action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_PHONES', {type: $event.type, action: false}));
      }
    });

    this.$bus.$on('company::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_COMPANY', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_COMPANY', {action: false}))
      }
    });
    this.$bus.$on('company_contracts::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_COMPANY_CONTRACTS', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_COMPANY_CONTRACTS', {action: false}))
      }
    });
    this.$bus.$on('company_credit_finance::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_COMPANY_CREDIT_FINANCE', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_COMPANY_CREDIT_FINANCE', {action: false}))
      }
    });
    this.$bus.$on('company_health_check::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_COMPANY_HEALTH_CHECK', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_COMPANY_HEALTH_CHECK', {action: false}))
      }
    });
    this.$bus.$on('service_check_reports::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_SERVICE_COMPANY_REPORTS', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_SERVICE_COMPANY_REPORTS', {action: false}))
      }
    });
    this.$bus.$on('company_payment_process::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_COMPANY_PAYMENT_PROCESS_INFO', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_COMPANY_PAYMENT_PROCESS_INFO', {action: false}))
      }
    });
    this.$bus.$on('company_pre_agreement::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_PRE_AGREEMENT', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_PRE_AGREEMENT', {action: false}));
      }
    });
    this.$bus.$on('company_referral::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_COMPANY_REFERRALS', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_COMPANY_REFERRALS', {action: false}))
      }
    });
    this.$bus.$on('company_services::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_COMPANY_SERVICES', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_COMPANY_SERVICES', {action: false}))
      }
    });

    this.$bus.$on('contacts::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_CONTACTS', {type: $event.type, action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_CONTACTS', {type: $event.type, action: false}));
      }
    });

    this.$bus.$on('default_company_ts_auth::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_DEFAULT_CLIENT_TS_AUTH', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_DEFAULT_CLIENT_TS_AUTH', {action: false}))
      }
    });

    this.$bus.$on('assignments::reload', ($event) => {
      if ($event.action === true) {
        this.$store.commit('RELOAD_ASSIGNMENTS', {action: $event.action});
        this.$nextTick(() => this.$store.commit('RELOAD_ASSIGNMENTS', {action: false}))
      }
    });
  },
  destroyed() {
    this.$bus.off();
  }
}
</script>
